import { MULTI_GROUP_CF_TYPE, GROUP_CF_TYPE } from '@atlassian/jira-platform-field-config';
import type { RichValue, StringValue } from '../../../value/types';
import type { TransformedSingleGroup, TransformedMultipleGroup, Group } from '../types';

const getSingleGroupValue: StringValue<TransformedSingleGroup> = (field) => field.value?.name ?? '';
const getMultipleGroupValue: StringValue<TransformedMultipleGroup> = (field) =>
	field.value == null ? '' : field.value.map((v) => v?.name).join(',');

const getSingleGroupRichValue: RichValue<TransformedSingleGroup, Group> = (field) =>
	field.value ?? null;

const getMultipleGroupRichValue: RichValue<TransformedMultipleGroup, Group[]> = (field) =>
	field.value ?? [];

export const groupStringValueHandler = {
	[GROUP_CF_TYPE]: getSingleGroupValue,
	[MULTI_GROUP_CF_TYPE]: getMultipleGroupValue,
};

export const groupRichValueHandler = {
	[GROUP_CF_TYPE]: getSingleGroupRichValue,
	[MULTI_GROUP_CF_TYPE]: getMultipleGroupRichValue,
};
